import { useState } from 'react'
import PropTypes from 'prop-types'

import CheckboxField from '../FormLegacy/FormFieldsV2/CheckboxField'

export const PreviewCheckbox = ({ value, name, label }) => {
  const [checked, setChecked] = useState(false)

  return (
    <CheckboxField
      name={name}
      value={value}
      label={label}
      checked={checked}
      onChange={() => setChecked((prev) => !prev)}
    />
  )
}

PreviewCheckbox.propTypes = {
  value: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
}

export default PreviewCheckbox
